import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./BrowseTemplate.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosClose } from "react-icons/io";
import { themeColors } from "../../theme";
import BrowseWhatsappTemplates from "../DispositionWhatsappTemplates/BrowseWhatsappTemplates";
import TemplateSearch from "../../TemplateSearch/TemplateSearch";
import CustomButton from "../Button/CustomButton";
import { showSnackbarAction } from "../../../Redux/actions";
import Backdrop from "../../Backdrop/Backdrop";
import { AiOutlineSearch } from "react-icons/ai";
import {
  fetchBrowseTemplate,
  searchTemplate,
} from "../../../Services/marketingAutomation";
import { AiOutlineClose } from "react-icons/ai";

type props = {
  close: () => void;
  open: boolean;
  theme?: any;
  user?: any;
  setExcelTemplateHeader?: (name: Array<Record<string, any>>) => void;
  setTemplateData?: any;
  setBrowseContactInputText?: any;
  setSelectedValues?: any;
  setTemplateMSG?: any;
  setExcelContact?:any;
};

const slideInFromRight = {
  hidden: {
    translateX: "0%", // Move off-screen to the right, without affecting layout
    opacity: 0,
  },
  visible: {
    translateX: "0%", // Bring into view
    opacity: 1,
    transition: {
      duration: 0.25,
      ease: "linear",
    },
  },
  exit: {
    translateX: "0%", // Slide out without triggering horizontal scrollbars
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: "linear",
    },
  },
};

const BrowseTemplate: FunctionComponent<props> = ({
  close,
  open,
  theme,
  user,
  setTemplateData,
  setBrowseContactInputText,
  setSelectedValues,
  setTemplateMSG,
  setExcelContact
}) => {
  // const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
  // const [newMobileNumber, setNewMobileNumber] = useState("");

  // const dispatcher = useDispatch();
  const dispatcher = useDispatch();

  const [selectedTemplate, setSelectedTemplate] = useState<any>("");
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [activeTab, setActiveTab] = useState<string | number>("Pre Launch");
  const [fetchBrowseTemp, setFetchBrowseTemp] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const PAGE_SIZE = 5;
  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
  const isLastPage = page >= totalPages;


  const browseTemplate = async (selectedTab: any) => {
    const browseTemplateData = await fetchBrowseTemplate(selectedTab, page, setTotalCount);
    setFetchBrowseTemp(browseTemplateData);
  };

  useEffect(() => {
    setSearchQuery("");
    setPage(1);
  }, [activeTab]);

  useEffect(() => {
    browseTemplate(activeTab);
  }, [activeTab, page]);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      fetchTemplateFromSearch();
    }
  };

  const fetchTemplateFromSearch = async () => {
    const result = await searchTemplate(searchQuery, activeTab);
    const templatesDataArray = [];
    let obj = result;
    for (let key in obj) {
      templatesDataArray.push({
        [key]: obj[key],
      });
    }
    setFetchBrowseTemp(templatesDataArray);
  };

  return (
    <>
      {/* {load === true && <Loading />} */}
      <AnimatePresence>
        {open && (
          <Backdrop>
            <motion.div
              key="modal"
              className="shadow"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                width: "35vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 3px 11px 0 rgba(0, 0, 0, 0.2)",
                zIndex: 1000,
                overflowX: "hidden",
                // gap: "1rem",
                // justifyContent: "center",
                // alignItems: "center",
                // ...containerStyles
                backgroundColor: "#fff",
              }}
              variants={slideInFromRight}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  padding: "1rem",
                  gap: "0.5rem",
                }}
              >
                <div className={styles.titleDiv}>
                  <p className={styles.title}>SELECT TEMPLATE</p>
                  <div onClick={close} style={{ cursor: "pointer" }}>
                    <IoIosClose size={35} color={"#808080"} />
                  </div>
                </div>
                <div className={styles.searchContainer}>
                  <input
                    type="text"
                    placeholder={`Search in ${activeTab}`}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    value={searchQuery}
                    onKeyDown={handleKeyDown}
                  />
                  {searchQuery === "" ? (
                    <AiOutlineSearch
                      color={"#000"}
                      style={{ cursor: "pointer" }}
                      size={18}
                      onClick={() => {
                        fetchTemplateFromSearch();
                      }}
                    />
                  ) : (
                    <AiOutlineClose
                      color={"#000"}
                      style={{ cursor: "pointer" }}
                      size={18}
                      onClick={() => {
                        setSearchQuery("");
                        browseTemplate(activeTab);
                      }}
                    />
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 2,
                  overflowY: "scroll",
                  marginRight: "10px",
                }}
              >
                <BrowseWhatsappTemplates
                  templatesDirectionCol={true}
                  selectedBrowseTemplate={setSelectedTemplate}
                  setActiveTabTemp={setActiveTab}
                  fetchBrowseTemp={fetchBrowseTemp}
                  page={page}
                  setPage={setPage}
                  isLastPage={isLastPage}
                />
              </div>
              <div className={styles.buttonsContainer}>
                <CustomButton
                  text="Cancel"
                  onClick={close}
                  buttonType="secondary"
                />
                <CustomButton
                  text="Select"
                  onClick={() => {
                    if (selectedTemplate === null) {
                      dispatcher(
                        showSnackbarAction("Please select a template", "error")
                      );
                      return;
                    } else {
                      setTemplateData(selectedTemplate);
                      setBrowseContactInputText([]);
                      setSelectedValues([]);
                      setTemplateMSG("");
                      setExcelContact("")
                      close();
                    }
                  }}
                  buttonType="primary"
                />
              </div>
            </motion.div>
          </Backdrop>
        )}
      </AnimatePresence>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(BrowseTemplate);
